<template>
    <div class="__l">
        <div class="flex justify-between mb-8 items-center">
            <div>
                <h1 class="text-4xl tracking-widest uppercase font-bold text-gray-700">Professional Writing</h1>
            </div>
            <div>
                <button class="btn-primary" type="button" @click="navigateToCopifyJobs">List Copify Jobs</button>
            </div>
        </div>

        <input type="text" class="form-field py-4 px-6" ref="searchbar"
               placeholder="Search for Professional Writing Requests" @keyup.enter="handleSearch" v-model="search">

        <div v-if="results.data && search" class="my-2 text-center">
            <p>The total number of results for <strong>"{{ search }}"</strong> is <strong>{{ results.total }}</strong>
            </p>
        </div>
        <div v-if="results.data && !search" class="my-2 text-center">
            <p>The total number of results is <strong>{{ results.total }}</strong></p>
        </div>
        <div class="results-list" v-if="results.data">
            <div class="results-row">
                <div class="results-head" data-width="10%">Id</div>
                <div class="results-head" data-width="30%">Email</div>
                <div class="results-head" data-width="10%">Date</div>
                <div class="results-head" data-width="10%">Status</div>
                <div class="results-head" data-width="40%">Subject</div>
            </div>
            <div class="results-row" v-for="(result, index) in results.data" :key="index" @click="handleSelect(result)">
                <div class="results-cell" data-width="10%">{{ result.id }}</div>
                <div class="results-cell" data-width="30%">{{
                        result.user ? result.user.email : "[User Removed]"
                    }}
                </div>
                <div class="results-cell" data-width="10%">{{ formatDateShort(result.created_at) }}</div>
                <div class="results-cell status" data-width="10%"><span
                    :class="buildCssClass(statusList[result.status || 0])">{{
                        statusList[result.status] || 'Status not set'
                    }}</span></div>
                <div class="results-cell" data-width="40%">{{ result.subject }}</div>
            </div>
            <pagination v-if="results.data" v-model="page" :records="results.total" :per-page="25" @paginate="loadData"></pagination>
            <div class="results-row" v-if="!results.data">
                <div class="results-span text-center" data-width="100%">
                    <p>No results found</p>
                </div>
            </div>
        </div>
        <router-view v-slot="{ Component }">
            <transition name="drop-in" mode="in-out">
                <component :is="Component"></component>
            </transition>
        </router-view>
    </div>
</template>

<script>
import Pagination from 'v-pagination-3'

export default {
    name: 'ProfessionalWriting',
    data() {
        return {
            search: null,
            results: {},
            statusList: [],
            showAll: 0,
            page: 1,
        }
    },
    components: {
        Pagination
    },
    mounted() {
        this.loadData()
        this.setMetaTitle('List Professional Writing Requests | JournoLink Control')
    },
    methods: {
        handleSearch() {
            this.loadData()
        },
        getStatusList() {
            return axios.get(route('professionalWriting.status'))
        },
        getProfessionalWriting(page) {
            return axios.get(route('professionalWriting.list'), {
                params: {
                    term: this.search,
                    page: page,
                    showAll: this.showAll,
                },
            })
        },
        /**
         * Load the results from the data provider
         *
         * @return {void}
         */
        loadData() {
            axios.all([this.getProfessionalWriting(this.page), this.getStatusList()])
                .then(axios.spread((responseWriting, responseStatus) => {
                    this.results = responseWriting.data.results
                    this.statusList = responseStatus.data.statusList
                }))
                .catch(e => {
                    this.$bus.$emit('alert.danger', 'There was an error retrieving professional writing requests')
                })
        },
        /**
         * handle the selection of a professional writing request
         * professional writing request
         * @return {void}
         */
        handleSelect(result) {
            this.$router.push({
                name: 'professionalWriting.show', params: {
                    professionalWritingId: result.id
                }
            })
        },
        /**
         * create some css classes for each status
         * @param  {string} status
         * @return {string} css friendly status
         */
        buildCssClass(status) {
            return status.toLowerCase().replace(' ', '-')
        },
        /**
         * Navigate to the list of Copify Jobs
         *
         * @return {void}
         */
        navigateToCopifyJobs() {
            this.$router.push({name: 'professionalWriting.copify'})
        },
    },
}
</script>
<style lang="less">
.status {
    span {
        padding: 5px;
        border-radius: 3px;
        color: white;
    }

    .unfulfilled {
        background: #cc1f1a;
    }

    .order-received {
        background: #b7d9ef;
    }

    .writer-received {
        background: #dde0e2;
    }

    .in-progress {
        background: #2980b9;
    }

    .complete {
        background: #2c3e50;
    }
}
</style>
